(function() {
    'use strict';
    
a3_cabin_reports.factory('FlightCrewMemberFactory',  FlightCrewMemberFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightCrewMemberFactory
    * @description 
    *   Add, Update, Delete and Get Flight Crew Members.
    * @ngInject
    */    
function FlightCrewMemberFactory(GenericModalFactory) {

        /**
        * Initialize the FlightCrewMember
        * @memberof FlightCrewMemberFactory
        */
		function FlightCrewMember() {
			this.aimsId = null;
			this.id = null;
			this.isDHC = null;
			this.name = null;
			this.position = null;
			this.sex = null;
			this.shortname = null;
		}
		
	 	var service = {
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}

         /**
         * Extend Object from the default FlightCrewMember Object
         * @memberof FlightCrewMemberFactory
         * @param {Object} obj a FlightCrewMember
         * @returns {Object} FlightCrewMember
         */
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,FlightCrewMember)
		}

        /**
         * Delete object from given list and update it
         * @memberof FlightCrewMemberFactory
         * @param {object} obj  a Flight Crew Member
         * @param {Array} objList  an Array Of Flight Crew Member
         * @returns {Array} FlightCrewMembers
         *
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}

        /**
         * Extend an array of Objects from the default Flight Crew Member Object
         * @memberof FlightCrewMemberFactory
         * @param {Array} objList  an Array Of Flight Crew Member
         * @returns {Array} FlightCrewMembers
         */
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,FlightCrewMember)
		}

		return service;
	}

    })();